"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCssVars = void 0;
var _react = _interopRequireDefault(require("react"));
var _useThemeCssVars2 = require("./useThemeCssVars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var withCssVars = exports.withCssVars = function withCssVars(Component) {
  var WrappedComponent = function WrappedComponent(props) {
    var _useThemeCssVars = (0, _useThemeCssVars2.useThemeCssVars)(),
      theme = _useThemeCssVars.theme,
      getCssVar = _useThemeCssVars.getCssVar;
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      theme: theme,
      getCssVar: getCssVar
    }));
  };
  WrappedComponent.displayName = "WithCssVars(".concat(Component.displayName || Component.name || 'Component', ")");
  return WrappedComponent;
};